// source: device.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.unifiedplatform.heartIntuneProfile.device.Device', null, global);
goog.exportSymbol('proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest', null, global);
goog.exportSymbol('proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.unifiedplatform.heartIntuneProfile.device.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.unifiedplatform.heartIntuneProfile.device.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.unifiedplatform.heartIntuneProfile.device.Device.displayName = 'proto.unifiedplatform.heartIntuneProfile.device.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.displayName = 'proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.repeatedFields_, null);
};
goog.inherits(proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.displayName = 'proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.unifiedplatform.heartIntuneProfile.device.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    platform: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    versionbaseos: jspb.Message.getFieldWithDefault(msg, 5, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 6, ""),
    model: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isphysicaldevice: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    appversion: jspb.Message.getFieldWithDefault(msg, 9, ""),
    fcmtoken: jspb.Message.getFieldWithDefault(msg, 10, ""),
    buildcodeversion: jspb.Message.getFieldWithDefault(msg, 11, ""),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifieddate: (f = msg.getModifieddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    firebaseid: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.unifiedplatform.heartIntuneProfile.device.Device;
  return proto.unifiedplatform.heartIntuneProfile.device.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionbaseos(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsphysicaldevice(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFcmtoken(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuildcodeversion(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifieddate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirebaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.unifiedplatform.heartIntuneProfile.device.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVersionbaseos();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsphysicaldevice();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAppversion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFcmtoken();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBuildcodeversion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifieddate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFirebaseid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string UUID = 2;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string platform = 3;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string versionBaseOS = 5;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getVersionbaseos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setVersionbaseos = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string manufacturer = 6;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setManufacturer = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string model = 7;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool isPhysicalDevice = 8;
 * @return {boolean}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getIsphysicaldevice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setIsphysicaldevice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string appVersion = 9;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getAppversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setAppversion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fcmToken = 10;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getFcmtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setFcmtoken = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string buildCodeVersion = 11;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getBuildcodeversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setBuildcodeversion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
*/
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp modifiedDate = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getModifieddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
*/
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setModifieddate = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.clearModifieddate = function() {
  return this.setModifieddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.hasModifieddate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string firebaseId = 14;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.getFirebaseid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.Device.prototype.setFirebaseid = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    platform: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    versionbaseos: jspb.Message.getFieldWithDefault(msg, 4, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 5, ""),
    model: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isphysicaldevice: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    appversion: jspb.Message.getFieldWithDefault(msg, 8, ""),
    fcmtoken: jspb.Message.getFieldWithDefault(msg, 9, ""),
    buildcodeversion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    modifieddate: (f = msg.getModifieddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    firebaseid: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest;
  return proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionbaseos(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsphysicaldevice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversion(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFcmtoken(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuildcodeversion(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifieddate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirebaseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVersionbaseos();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsphysicaldevice();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getAppversion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFcmtoken();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBuildcodeversion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getModifieddate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFirebaseid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string UUID = 1;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string platform = 2;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string versionBaseOS = 4;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getVersionbaseos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setVersionbaseos = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string manufacturer = 5;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setManufacturer = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string model = 6;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool isPhysicalDevice = 7;
 * @return {boolean}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getIsphysicaldevice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setIsphysicaldevice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string appVersion = 8;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getAppversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setAppversion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string fcmToken = 9;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getFcmtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setFcmtoken = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string buildCodeVersion = 10;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getBuildcodeversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setBuildcodeversion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp modifiedDate = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getModifieddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
*/
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setModifieddate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.clearModifieddate = function() {
  return this.setModifieddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.hasModifieddate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string firebaseId = 12;
 * @return {string}
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.getFirebaseid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.DeviceRequest.prototype.setFirebaseid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.toObject = function(opt_includeInstance) {
  return proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.toObject = function(includeInstance, msg) {
  var f, obj = {
    devicelistList: jspb.Message.toObjectList(msg.getDevicelistList(),
    proto.unifiedplatform.heartIntuneProfile.device.Device.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices;
  return proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.unifiedplatform.heartIntuneProfile.device.Device;
      reader.readMessage(value,proto.unifiedplatform.heartIntuneProfile.device.Device.deserializeBinaryFromReader);
      msg.addDevicelist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicelistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.unifiedplatform.heartIntuneProfile.device.Device.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Device deviceList = 1;
 * @return {!Array<!proto.unifiedplatform.heartIntuneProfile.device.Device>}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.getDevicelistList = function() {
  return /** @type{!Array<!proto.unifiedplatform.heartIntuneProfile.device.Device>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.unifiedplatform.heartIntuneProfile.device.Device, 1));
};


/**
 * @param {!Array<!proto.unifiedplatform.heartIntuneProfile.device.Device>} value
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices} returns this
*/
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.setDevicelistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.unifiedplatform.heartIntuneProfile.device.Device=} opt_value
 * @param {number=} opt_index
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.Device}
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.addDevicelist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.unifiedplatform.heartIntuneProfile.device.Device, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices} returns this
 */
proto.unifiedplatform.heartIntuneProfile.device.ListOfDevices.prototype.clearDevicelistList = function() {
  return this.setDevicelistList([]);
};


goog.object.extend(exports, proto.unifiedplatform.heartIntuneProfile.device);
